import { useMemo } from "react";
import { PropTypes } from "base/react-libs";
import { ProgressBar } from "@evertrue/et-components";
import { countTasksForJourney, percentOfStepTasksComplete } from "apps/journeys/utils/helpers/counters";
import Card from "components/containers/card";
import classNames from "classnames";

const formatPercent = (percent) => {
  if (!percent) return 0;
  return Math.floor(percent.toFixed(2) * 100);
};

// DESPERATELY NEEDS RESTYLING
const JourneysTaskTableHeader = ({ journey = {} }) => {
  const { steps } = journey;
  const string = JSON.stringify(steps);
  const completionPercentage = useMemo(() => {
    if (string) return percentOfStepTasksComplete(steps);
    else return 0;
  }, [steps, string]);

  const counts = useMemo(() => {
    if (string) {
      const counts = countTasksForJourney(journey);
      delete counts.Completed; // don't visualize completed tasks here
      return counts;
    } else return {};
  }, [journey, string]);

  return (
    <div className="journeys-task-table--header">
      <Card className={"task-counter-card"}>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <table className="task-counter-card--details">
            <tbody>
              <tr>
                {Object.entries(counts).map(([_, count]) => (
                  <td key={`${_}${count}`}>{count}</td>
                ))}
              </tr>
              <tr>
                {Object.entries(counts).map(([name, _]) => (
                  <td key={`${name}${_}`}>{name}</td>
                ))}
              </tr>
            </tbody>
          </table>
          <div className={classNames("progress-bar-with-label--bar", "thin")}>
            <div style={{ paddingRight: "8px" }} className="progress-bar-with-label--title">
              Progress
            </div>
            <ProgressBar width={100} percent={completionPercentage} progressColor="#73c166" className={"thin"} />
            <span className="progress-bar-with-label--percent-label">{`${formatPercent(completionPercentage)}%`}</span>
          </div>
        </div>
      </Card>
    </div>
  );
};

JourneysTaskTableHeader.propTypes = {
  journey: PropTypes.object,
};

export default JourneysTaskTableHeader;
